import React from 'react';
import s from './s.module.less';

/**
 * 蓝色说明条。原型 .info-banner —— 两处用它：
 *  - #notListed：还没上架，所以上限无从生效
 *  - #roStrip：只有 owner / admin 能改这个上限
 *
 * 之前把这两条降级成了灰色小字（cardSub / limitHelper），
 * 但「为什么控件不能用」「谁才有权改」是 provider 进来最先要问的两件事，
 * 设计稿刻意给了它们一个独立的、带图标的蓝条。
 *
 * 蓝色取本仓既有的语义蓝（var(--blue-50/800)，FollowUpModal、StepBanner 都在用），
 * 两套门户共用；只有图标底色跟品牌色走，和原型一致（原型图标是 var(--brand)）。
 */
const InfoBanner: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <div className={s.infoBanner}>
        <div className={s.infoBannerIcon}>i</div>
        <div className={s.infoBannerText}>{children}</div>
    </div>
);

export default InfoBanner;
